import { withDefaultContextAsSelectedProject } from './api-default-context';

export const getAutoTieoutMapedElements = ({
  clientId,
  sourceStatementId,
  targetStatementId,
  sourceRevisionId,
  targetRevisionId,
}) => {
  return withDefaultContextAsSelectedProject()
    .get(
      `/tieout/client/${clientId}/statements/source/${sourceStatementId}/target/${targetStatementId}/revisions/source/${sourceRevisionId}/target/${targetRevisionId}/autotieout/mapping`,
    )
    .then((response) => {
      return response;
    });
};
